import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ResultsData } from "../../state/UserPermissions/ResultsData";

const updateResultsData: Reducer<ResultsData> = (state: ResultsData = new ResultsData(), action: Action<ActionType, ResultsData>) => {
  switch (action.type) {
    case ActionType.USER_PERMISSIONS_DATA_FETCHED:
      return { ...state, ...action.data};
    default:
      return state;
  }
};

export default updateResultsData;
